// extracted by mini-css-extract-plugin
export default {"paginateWrapper":"styles_paginateWrapper__aHZmH","loader":"styles_loader__ApVg8","container":"styles_container__ofXg3","active":"styles_active__Mi-wn"};